module.exports = __webpack_public_path__ + "static/media/logopink.17679618.png";